import { createFileRoute } from "@tanstack/react-router";

import { ConsolePairMachine } from "../features/console/account";

export const Route = createFileRoute("/console/machines/pair")({
  component: ConsolePairMachine,
});
